import { Status } from '../types/documents.type';

export const STATUS_COLOR = {
  [Status.Draft]: { background: '#E7F9F9', color: '#00B1B4' },
  [Status.Published]: { background: '#EBFFEE', color: '#009951' },
  [Status.Unpublished]: { background: '#FFEDDA', color: '#F4511E' },
};
